import { styled } from '@mui/system'
import { ARTICLE_CARD_SIZE, colors, fontSizes } from '../../consts'

type stylesProps = {
  color?: string
  uiTheme?: 'light' | 'dark'
  size?: 'home_featured' | 'normal' | 'small' | 'featured'
}

export const ArticleCon = styled('div')<stylesProps>(({ size, uiTheme, theme }) => ({
  width: size ? ARTICLE_CARD_SIZE[size].desktop : 420,
  position: 'relative',
  [theme.breakpoints.between('md', 'lg')]: {
    width: size ? ARTICLE_CARD_SIZE[size].tablet : 350,
  },
  [theme.breakpoints.between('sm', 'md')]: {
    width: size ? ARTICLE_CARD_SIZE[size].mobile : 300,
  },
  [theme.breakpoints.down('sm')]: {
    width: size ? ARTICLE_CARD_SIZE[size].smMobile : 280,
  },
  '& a': {
    color: uiTheme === 'dark' ? colors.white : colors.text,
    textDecoration: 'none',
    cursor: 'pointer',
    '& .cover, & .placeholder': {
      borderRadius: theme.spacing(1),
      width: '100%',
      height: size ? calculateHeight(ARTICLE_CARD_SIZE[size].desktop) : 236.25,
      objectFit: 'cover',
      [theme.breakpoints.between('md', 'lg')]: {
        height: size ? calculateHeight(ARTICLE_CARD_SIZE[size].tablet) : 196.875,
      },
      [theme.breakpoints.between('sm', 'md')]: {
        height: size ? calculateHeight(ARTICLE_CARD_SIZE[size].mobile) : 196.875,
      },
      [theme.breakpoints.down('sm')]: {
        height: size ? calculateHeight(ARTICLE_CARD_SIZE[size].smMobile) : 196.875,
      },
    },
  },
}))

export const TitleCon = styled('div')<stylesProps>(({ uiTheme, theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  alignItems: 'start',
  margin: theme.spacing(1, 1, 0),
}))

export const PartnerLabel = styled('div')<stylesProps>(({ uiTheme, theme }) => ({
  display: 'inline-block',
  backgroundColor: uiTheme === 'dark' ? colors.gray.gray20 : colors.gray.gray20,
  borderRadius: theme.spacing(1),
  margin: theme.spacing(1, 1, 0, 0),
  justifySelf: 'start',
  padding: theme.spacing(0.25, 1),
  '& p': {
    color: uiTheme === 'dark' ? colors.white : colors.black,
    fontWeight: 'bold',
    fontSize: fontSizes.xSmall,
    whiteSpace: 'nowrap',
    margin: 0
  },
}))

export const ArticleTitle = styled('h2')<stylesProps>(({ uiTheme, theme }) => ({
  fontWeight: 'bold',
  fontSize: fontSizes.medium,
  color: uiTheme === 'dark' ? colors.white : colors.text,
  marginTop: theme.spacing(1),
  alignSelf: 'flex-start',
  gridColumn: '1 / -1',
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.small,
  },
}))

export const ArticleAuthor = styled('div')<stylesProps>(({ uiTheme, theme }) => ({
  margin: theme.spacing(0, 1, 0),
  fontSize: fontSizes.small,
  color: uiTheme === 'dark' ? colors.white : colors.text,
}))

export const AdditionalHeadlinesCon = styled('div')<stylesProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}))

const calculateHeight = (sizeValue: string | number) => {
  if (typeof sizeValue === 'number') {
    return (sizeValue / 16) * 9
  }
  if (sizeValue.endsWith('px')) {
    const width = parseInt(sizeValue.replace('px', ''), 10)
    return `${(width / 16) * 9}px`
  }
  if (sizeValue.endsWith('%')) {
    return '56.25%' // 9 / 16 = 0.5625
  }
  return 236.25
}
